import { Box, Flex } from "@chakra-ui/react"
import { NAVY } from "./constants"

export const BOT_ICON_SRC = "/TCT_AI_Icon.svg"

export default function BotAvatar() {
    return (
        <Flex align="center" justify="center" w="28px" h="28px" borderRadius="full" bg={NAVY} flexShrink={0}>
            <Box as="img" src={BOT_ICON_SRC} alt="" w="16px" h="auto" maxW="none" />
        </Flex>
    )
}
